// Source: app/scripts/controllers/companies-for-approval.js
/**
 * Created by ristes on 20.4.15.
 */


Auction.controller('CompaniesForApprovalController', [
  '$scope',
  '$filter',
  '$modal',
  'crudService',
  'toaster',
  function ($scope, $filter, $modal, crudService, toaster) {

    var service = crudService('registered_users', {
      approve: {
        method: 'POST',
        url: "/data/rest/registered_users/approve"
      },
      reject: {
        method: 'POST',
        url: "/data/rest/registered_users/reject"
      },
      enable: {
        method: 'POST',
        url: "/data/rest/registered_users/enable"
      },
      disable: {
        method: 'POST',
        url: "/data/rest/registered_users/disable"
      },
      block: {
        method: 'POST',
        url: "/data/rest/registered_users/block"
      },
      getLog: {
        method: 'GET',
        url: '/data/rest/users/log',
        isArray: true
      },
      getBankGuarantees: {
        method: 'GET',
        url: '/data/rest/bank_guarantees/by_username',
        isArray: true
      },
      editTemporaryCompany: {
        method: 'POST',
        url: "/data/rest/temporary_companies"
      }
    });


    $scope.crudTitle = "portal.companies";
    $scope.disableEntity = {};
    $scope.company = {};

    $scope.modalEditCompany = $modal({
      scope: $scope,
      template: 'forms/admin/auth/companies_for_approval.html',
      show: false
    });

    $scope.modalDisable = $modal({
      scope: $scope,
      template: 'forms/modals/disable.html',
      show: false
    });
    $scope.rejectEntity = {};
    $scope.blockEntity = {};
    $scope.modalReject = $modal({
      scope: $scope,
      template: 'forms/modals/reject_trader.html',
      show: false
    });
    $scope.modalBlock = $modal({
      scope: $scope,
      template: 'forms/modals/block_company.html',
      show: false
    });

    $scope.disable = function () {
      service.disable({
        username: $scope.disableEntity.username,
        days: $scope.disableEntity.days
      }, function () {
        $scope.modalDisable.hide();
        delete $scope.disableEntity.days;
        $scope.traderCrud.reload();
        $scope.traderCrud.edit($scope.disableEntity.id);
        $scope.disableEntity = {};
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')("eauction.disable"));
      });
    };

    $scope.reject = function () {
      service.reject({
        registeredUser: $scope.rejectEntity.registeredUser,
        rejectReason: $scope.rejectEntity.rejectReason
      }, function () {
        $scope.modalReject.hide();
        $scope.traderCrud.reload();
        delete $scope.rejectEntity.rejectReason;
        $scope.rejectEntity = {};
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')("REJECTED"));
      });
    };

    $scope.block = function () {
      service.block({
        registeredUser: $scope.blockEntity.registeredUser,
        blockReason: $scope.blockEntity.blockReason
      }, function () {
        $scope.modalBlock.hide();
        $scope.traderCrud.reload();
        delete $scope.blockEntity.blockReason;
        $scope.blockEntity = {};
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')("BLOCKED"));
      });
    };

    $scope.editTemporaryCompany = function (){
      service.editTemporaryCompany( $scope.company, function () {
        $scope.modalEditCompany.hide();
        $scope.traderCrud.reload();
        $scope.company = {};
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')("EDITED"));
      });
    };





    $scope.onSelect = function (crudScope, entity) {
      crudScope.licenseTypeUpload = {};
      crudScope.tlt = {};
      crudScope.log = service.getLog({
        code: entity.username
      });
      crudScope.bankGuarantees = service.getBankGuarantees({
        username: entity.username
      });
      crudScope.editLicenseType = function (attachment, bean) {
        licenseTypeService.get({id: attachment.objectId}, function (lt) {
          crudScope.tlt.traderLicenseTypeId = lt.id;
          crudScope.tlt.licenseType = lt.licenseType;
          crudScope.tlt.licenseValidFrom = lt.validFrom;
          crudScope.tlt.licenseValidTo = lt.validTo;
          crudScope.tlt.attachmentId = attachment.id;
          crudScope.tltattachment = attachment;
        });
      };
      crudScope.updateTraderLicenseType = function (attachment, bean) {
        licenseTypeService.update({
          id: crudScope.tltattachment.objectId
        }, {
          licenseType: crudScope.tlt.licenseType,
          validFrom: crudScope.tlt.licenseValidFrom,
          validTo: crudScope.tlt.licenseValidTo
        }, function () {
          toaster.pop('success', $filter('translate')('generic.success'),
            $filter('translate')("action.saved"));
          crudScope.finishEditing();
          crudScope.licenseTypeUpload.scope.reload();
        });
      };
      crudScope.finishEditing = function () {
        crudScope.tlt = {};
      }
    };

    $scope.actions = [{
      text: 'eauction.approve',
      name: 'approve',
      position: 'right',
      classes: 'btn btn-primary',
      iconClass: 'fa fa-fw fa-check',
      enabled: false,
      onClick: function (entity) {
        service.approve({
          trader: entity
        }, function () {
          $scope.traderCrud.reload();
          $scope.traderCrud.edit(entity.id);
          toaster.pop('success', $filter('translate')('generic.success'),
            $filter('translate')("APPROVED"));
        });
      }
    }, {
      text: 'eauction.reject',
      name: 'reject',
      position: 'right',
      classes: 'btn btn-danger',
      iconClass: 'fa fa-fw fa-close',
      enabled: false,
      onClick: function (entity) {
        $scope.rejectEntity.registeredUser = entity;
        $scope.modalReject.$promise.then($scope.modalReject.show);
      }
    }, {
      text: 'eauction.enable',
      name: 'enable',
      position: 'right',
      classes: 'btn btn-primary',
      iconClass: 'fa fa-fw fa-toggle-on',
      enabled: false,
      onClick: function (entity) {
        service.enable({
          username: entity.username
        }, function () {
          $scope.traderCrud.reload();
          $scope.traderCrud.edit(entity.id);
          toaster.pop('success', $filter('translate')('generic.success'),
            $filter('translate')("eauction.enable"));
        });
      }
    }, {
      text: 'eauction.disable',
      name: 'disable',
      position: 'right',
      classes: 'btn btn-danger',
      iconClass: 'fa fa-fw fa-toggle-off',
      enabled: false,
      onClick: function (entity) {
        $scope.disableEntity = entity;
        $scope.modalDisable.$promise.then($scope.modalDisable.show);
      }
    }, {
      text: 'portal.block',
      name: 'block',
      position: 'right',
      classes: 'btn btn-danger',
      iconClass: 'fa fa-fw fa-close',
      enabled: false,
      onClick: function (entity) {
        $scope.blockEntity.registeredUser = entity;
        $scope.modalBlock.$promise.then($scope.modalBlock.show);
      }
    }];


    $scope.afterInit = function (crudScope) {

      crudScope.disableUser = function (entity) {
        $scope.disableEntity = entity;
        $scope.modalDisable.$promise.then($scope.modalDisable.show);
      };


      crudScope.enableUser = function (entity) {
        service.enable({
          username: entity.username
        }, function () {
          $scope.traderCrud.reload();
          $scope.traderCrud.edit(entity.id);
          toaster.pop('success', $filter('translate')('generic.success'),
            $filter('translate')("ENABLED"));
        });
      };

      crudScope.approveUser = function (entity) {
        service.approve({
          registeredUser: entity
        }, function () {
          $scope.traderCrud.reload();
          $scope.traderCrud.edit(entity.id);
          toaster.pop('success', $filter('translate')('generic.success'),
            $filter('translate')("APPROVED"));
        });
      };

      crudScope.rejectUser = function (entity) {
        $scope.rejectEntity.registeredUser = entity;
        $scope.modalReject.$promise.then($scope.modalReject.show);
      };

      crudScope.blockUser = function (entity) {
        $scope.blockEntity.registeredUser = entity;
        $scope.modalBlock.$promise.then($scope.modalBlock.show);
      };

      crudScope.editTemporaryCompany = function(temporaryCompany){
        $scope.company = temporaryCompany;
        $scope.modalEditCompany.$promise.then($scope.modalEditCompany.show);

      }



    };
  }
]);
